import React, { useEffect, useRef } from 'react';

import { Col, Row } from '@thd-olt-component-react/grid';
import './CpaConfirmation.scss';
import PropTypes from 'prop-types';
import { scrollToRef, imageBaseUrl } from '../../constants/constants';

const CpaConfirmation = (props) => {
  const {
    response, success
  } = props;
  const { value } = response;

  const topOfConfirmationRef = useRef();

  useEffect(() => {
    scrollToRef(topOfConfirmationRef);
  });

  // TODO: Reconsider how we are defaulting
  const { requestTypes, lnResponse } = value;
  const isOptOutRequest = (requestTypes)?.includes('Opt Out of Sale');
  const isLimitSPIRequest = (requestTypes)?.includes('Limit Use of My Sensitive Information');
  const requires2fa = !(isLimitSPIRequest || isOptOutRequest);
  const lnStatusNotPending = (isOptOutRequest || isLimitSPIRequest || lnResponse.questionSet === null);
  const successIcon = imageBaseUrl + '/alert-check-green.svg';
  const failureIcon = imageBaseUrl + '/alert-error-red.svg';
  let url = success ? successIcon : failureIcon;

  const verificationMessage = lnStatusNotPending ? '' : 'Your identity has been successfully verified.';

  return (
    <div
      id="confirmation-form"
      className="cpa-confirmation-card"
      ref={topOfConfirmationRef}
      data-component="CpaConfirmation"
    >
      <div className="cpa-confirmation-card__wrapper">
        <div className="cpa-confirmation-card--rounded">
          <div role="presentation" className="cpa-confirmation-card__body">
            <div className="cpa-confirmation-card__body--section">
              <Row>
                <Col sm="1">
                  <img
                    style={{ height: '80px', width: '80px' }}
                    src={url}
                    alt="Email Address"
                    height="80px"
                    width="80px"
                  />
                </Col>
                <Col sm="10">
                  {success && requires2fa && (
                    <h4>
                      <b> Request ID {value && (value.oneTrustRequestId)} is created.</b>
                      <br />
                      <b>{verificationMessage} Just one more step, {value && (value.firstName)}!</b>
                    </h4>
                  )}
                  {success && (isOptOutRequest || isLimitSPIRequest) && (
                    <h4>
                      <b> Request ID {value && (value.oneTrustRequestId)}.</b>
                      <br />
                      <b>Your request has been successfully submitted, {value && (value.firstName)}!</b>
                    </h4>
                  )}
                  {!success && (
                    <h4>
                      <br />
                      <b> We&apos;re sorry, {value && (value.firstName)}!</b>
                    </h4>
                  )}
                </Col>
                {success && requires2fa && (
                  <Col>
                    <p>
                      We will send you an email to confirm the email address that you provided.
                      To confirm your email address, please click CONFIRM in the email within six days.
                      If you do not see the email from us, please check your SPAM folder.
                      Our email will be sent from onetrust.com and will include your Request ID.
                    </p>
                  </Col>
                )}

                {!success && (
                  <Col>
                    <p>
                      We were unable to verify your identity based on the information you provided.
                      We therefore will not further process your request. If you believe there was
                      a mistake, you can contact us using the email address listed below, or you
                      can submit a new request&nbsp;
                      <a
                        href="https://www.homedepot.com/privacy/Exercise-My-Privacy-Rights"
                        className="text-link"
                      >
                        here
                      </a>. If you have any questions or if you are a resident of a state that
                      offers the right to appeal and want to appeal the outcome of your request,
                      please contact us by emailing&nbsp;
                      <a
                        href="mailto:myinfo@homedepot.com"
                        className="text-link"
                      >
                        myinfo@homedepot.com
                      </a>. If
                      you would like to opt out of the sale and sharing or use for targeted
                      advertising of your personal information, you can do so by visiting this page&nbsp;
                      <a
                        href="https://www.homedepot.com/privacy/Exercise-My-Privacy-Rights"
                        className="text-link"
                      >homedepot.com/privacy/Exercise-My-Privacy-Rights
                      </a>.
                    </p>
                    <p>
                      Please disregard the email we sent to confirm the email address you provided,
                      as the confirmation is required only if we verified your identity based on
                      the information you provided for verified requests. Even if you click CONFIRM
                      in that email, your request will not be processed.
                    </p>
                    <br />
                    <p style={{ fontSize: '18px' }}><b>Questions?</b></p>
                    <p>
                      Email us at&nbsp;
                      <a
                        href="mailto:myinfo@homedepot.com"
                        className="text-link"
                      >
                        myinfo@homedepot.com
                      </a>.
                    </p>
                    <p>
                      You may learn more about our privacy practices by going to our Privacy and
                      Security Statement at&nbsp;
                      <a
                        href="https://www.homedepot.com/privacy/privacy-and-security-statement"
                        className="text-link"
                      >
                        www.homedepot.com/privacy
                      </a>.
                    </p>

                  </Col>
                )}

                {success && isOptOutRequest && (
                  <Col>
                    <h5><b>Regarding Digital Opt Out of Sale Requests</b></h5>
                    <p>
                      When you submit an Opt Out of Sale request, your Digital Sales opt out
                      related to homedepot.com is completed for the device and browser you used
                      to submit the request. If you use other devices or browsers to access
                      homedepot.com or if you visit websites of The Home Depot’s affiliates or
                      partners, you will need to submit an opt out request using those devices
                      or browsers, or on those websites.  We also recognize the “Global Privacy Control”
                      (GPC) to allow you to opt out of the sale of your personal information and
                      the sharing of your personal information for targeted advertising on homedepot.com.
                      Please see the privacy policies of our affiliates or partners for more information.
                    </p>
                  </Col>
                )}

              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CpaConfirmation.propTypes = {
  response: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  success: PropTypes.bool.isRequired
};

CpaConfirmation.defaultProps = { response: { value: {
  oneTrustRequestId: 'TEST',
  firstName: 'FIRSTNAME',
  requestTypes: ['Opt Out of Sale'],
  lnResponse: {
    questionSet: null
  }
},
valid: false } };

CpaConfirmation.displayName = 'CpaConfirmation';

export { CpaConfirmation };
